import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import {
    PageContainer,
    PageSection,
    PageContent,
    PageTitle,
    PageSubtitle,
    containerVariants,
    itemVariants
} from '../styles/PageStyles';
import Form from '../components/Form/Form';

function SignUp() {
    const { t } = useTranslation();

    return (
        <PageContainer>
            <PageSection>
                <PageContent>
                    <motion.div
                        variants={containerVariants}
                        initial="hidden"
                        animate="visible"
                    >
                        <PageTitle variants={itemVariants}>
                            {t("navbar_data.5.text")}
                        </PageTitle>
                        
                        <PageSubtitle variants={itemVariants}>
                            Ponte en contacto con nosotros para más información sobre nuestros productos y servicios
                        </PageSubtitle>

                        <motion.div variants={itemVariants}>
                            <Form />
                        </motion.div>
                    </motion.div>
                </PageContent>
            </PageSection>
        </PageContainer>
    );
}

export default SignUp;